import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

import { CUSTOMERS_CREATE_LABEL } from '../../../constants/fulfillment-plan-ids';
import { RateBrowserAdapterForFulfillmentPlannerContext } from '../../../fulfillment-planner';
import Global from '../../../store/global-selectors';
import { updateShipmentConfiguration } from '../../../store/csw/csw.actions';
import CreateLabelContent from '../../create-label-content';
import { CUSTOMER_CREATE_LABEL } from '../../../constants/component-names';

const shipToSelector = createSelector(
  (state) => Global.selectSelectedCustomersIds(state),
  Global.selectCustomersGridCustomers,
  (selectedIds, customers) => {
    const selectedCustomerId = (selectedIds ?? [])[0];

    if (!selectedCustomerId) {
      return { shipTo: undefined, email: '' };
    }

    const customerEntity = customers.find((customer) => customer.customerId === selectedCustomerId);

    if (!customerEntity) {
      return { shipTo: undefined, email: '' };
    }

    return {
      shipTo: customerEntity.address,
      email: customerEntity.email,
    };
  },
);

export const RateBrowserAdapterWrapperForCustomerCreateLabel = () => {
  const dispatch = useDispatch();
  const { shipTo, email } = useSelector(shipToSelector);

  useEffect(() => {
    if (shipTo) {
      dispatch(updateShipmentConfiguration(CUSTOMERS_CREATE_LABEL, { shipTo, email }));
    }
  }, [dispatch, shipTo, email]);

  return (
    <RateBrowserAdapterForFulfillmentPlannerContext
      key={CUSTOMERS_CREATE_LABEL}
      fulfillmentPlanId={CUSTOMERS_CREATE_LABEL}
      initialEmailAddress={email}
      initialShipTo={shipTo}
      parentComponentName={CUSTOMER_CREATE_LABEL}
    >
      <CreateLabelContent fulfillmentPlanId={CUSTOMERS_CREATE_LABEL} />
    </RateBrowserAdapterForFulfillmentPlannerContext>
  );
};
